//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.PostEventsCiBuilder.js";
let d=[[[0,"CutType",1,0],[0,"Direction",1,0],[1,"EndOfTestCut",0,"CAM.PostEventsCiBuilder",0],[0,"FeedIn",1,0],[0,"FeedInAngle",1,0],[0,"FeedInLength",1,0],[0,"FeedOut",1,0],[0,"FeedOutAngle",1,0],[0,"FeedOutLength",1,0],[0,"MeasuringPoint",1,"Point",0],[0,"MeasuringPosition",1,0],[1,"MeasuringStop",0,"CAM.PostEventsCiBuilder",0],[0,"NumberOfPasses",1,0],[0,"ReturnMoveOption",1,0],[0,"ReturnMovePoint",1,"Point",0],[1,"SecondaryEndOfTestCut",0,"CAM.PostEventsCiBuilder",0],[1,"SecondaryMeasuringStop",0,"CAM.PostEventsCiBuilder",0],[0,"SecondarySequence",1,0],[1,"SecondaryStartOfTestCut",0,"CAM.PostEventsCiBuilder",0],[0,"Sequence",1,0],[1,"StartOfFinishPass",0,"CAM.PostEventsCiBuilder",0],[1,"StartOfTestCut",0,"CAM.PostEventsCiBuilder",0],[0,"Stock",1,0],[0,"StockMode",1,0],[0,"StopDistance",1,0],[0,"StopPercentage",1,0],[0,"StopPoint",1,"Point",0],[0,"StopPosition",1,0]],[],[]];
SPLM.CAM.TurnRoughFinishTestCut = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TurnRoughFinishTestCut";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TurnRoughFinishTestCut.SequenceTypes = Object.freeze({
    "None" : "None", "TestCutAndFinish" : "TestCutAndFinish", "TestCutOnly" : "TestCutOnly"});

SPLM.CAM.TurnRoughFinishTestCut.SecondarySequenceTypes = Object.freeze({
    "None" : "None", "Diameter" : "Diameter", "Face" : "Face"});

SPLM.CAM.TurnRoughFinishTestCut.CutTypes = Object.freeze({
    "Axial" : "Axial", "Contour" : "Contour"});

SPLM.CAM.TurnRoughFinishTestCut.DirectionTypes = Object.freeze({
    "Reverse" : "Reverse", "Forward" : "Forward"});

SPLM.CAM.TurnRoughFinishTestCut.MeasuringPositionTypes = Object.freeze({
    "Automatic" : "Automatic", "Point" : "Point", "SameAsFirstTestCut" : "SameAsFirstTestCut"});

SPLM.CAM.TurnRoughFinishTestCut.StockModeTypes = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify", "SameAsFirstTestCut" : "SameAsFirstTestCut"});

SPLM.CAM.TurnRoughFinishTestCut.StopPositionTypes = Object.freeze({
    "Automatic" : "Automatic", "Point" : "Point", "Length" : "Length", "Percent" : "Percent", "SameAsFirstTestCut" : "SameAsFirstTestCut"});

SPLM.CAM.TurnRoughFinishTestCut.FeedInTypes = Object.freeze({
    "None" : "None", "Linear" : "Linear", "SameAsProfileEngage" : "SameAsProfileEngage", "SameAsFirstTestCut" : "SameAsFirstTestCut"});

SPLM.CAM.TurnRoughFinishTestCut.FeedOutTypes = Object.freeze({
    "None" : "None", "Linear" : "Linear", "SameAsProfileRetract" : "SameAsProfileRetract", "SameAsFirstTestCut" : "SameAsFirstTestCut"});

SPLM.CAM.TurnRoughFinishTestCut.ReturnMoveTypes = Object.freeze({
    "Direct" : "Direct", "RadialAxial" : "RadialAxial", "AxialRadial" : "AxialRadial", "SameAsFirstTestCut" : "SameAsFirstTestCut"});

export default SPLM;